import AppConstants from '../config/app.constants';

let LedgerTransactionService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/ledger-transaction`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getLedgerDenomination = (search, offset, limit, orderNo, startDate, endDate , fundingSourceId) => {
        return $http
            .get(AppConstants.api + `/ledger-transaction/getLedgerDenomination`, {
                params: {
                    search,
                    offset,
                    limit,
                    orderNo,
                    startDate, 
                    endDate,
                    fundingSourceId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getLedgerAmountAndDenomBalance = (branchId, fundingSrcId, denominationId, account, vaultDate, currencyId) => {
        return $http
            .post(AppConstants.api + `/ledger-transaction/ledger-amount-and-denom-balance`, {
                // params: {
                    branchId, 
                    fundingSrcId, 
                    denominationId, 
                    account, 
                    vaultDate,
                    currencyId
                // }
            })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/ledger-transaction/get-ledger-transaction/${id}`)
            .then((res) => {
                return res.data
            })
    };

    let getLedgerDenomTotal = (branchId, account, denominationId, fundingSourceId ) => {
        return $http
            .post(AppConstants.api + `/ledger-transaction/get-ledger-denom-amount`, {
                branchId,
                account,
                denominationId,
                fundingSourceId
            })
            .then((res) => {
                return res.data
            })
    };

    const exportBulkCashHistoryExcel = (payload, fundingSourceName) => {
        return $q(function (resolve, reject) {
            var url = AppConstants.api + `/ledger-transaction/exportBulkCashHistory`;
            var xhr = new XMLHttpRequest();
            var sheetName = "";

            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhr.responseType = "arraybuffer";

            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = new Blob([xhr.response], { type: "application/xlsx" });
                    var a = document.createElement('a');

                    var safeFundingSourceName = (fundingSourceName || "").replace(/[<>:"/\\|?*]+/g, '_').trim();
                    sheetName = 'Bulk_Cash_History_' + safeFundingSourceName + '.xlsx';

                    a.href = URL.createObjectURL(blob);
                    a.download = sheetName;
                    a.click();
                    resolve();
                } else {
                    reject();
                }
            };

            xhr.send(JSON.stringify(payload));
        });
    };

    return {
        all,
        getLedgerDenomination,
        getLedgerAmountAndDenomBalance,
        get,
        getLedgerDenomTotal,
        exportBulkCashHistoryExcel
    };

};

LedgerTransactionService.$inject = ['$http', '$q']

export default LedgerTransactionService;



// WEBPACK FOOTER //
// ./client/app/services/ledger-transaction.service.js